import { treaty } from "@elysiajs/eden";
import {
  AttractedTo,
  CoreServerType,
  InferModel,
  ApiErrorCodeType,
  DomainErrorType,
  Gender,
} from "@neontree/bible-api-client";
import { QuizState } from "@base/types";

export type { AttractedTo, DomainErrorType, Gender };

//remove this
const eden = treaty<CoreServerType>("");

// /users/me attaches the caller project's current subscription (x-nt-project
// header). The /checkout/start reply does not, so the field stays optional.
type Me = InferModel<typeof eden.users.me.get>;
export type ServerSubscription = NonNullable<Me["subscription"]>;
export type ServerUser = Omit<Me, "subscription"> & {
  subscription?: ServerSubscription | null;
};

/** The answers a checkout page reads when it has no user (the email was taken). */
export type CheckoutAnswers = {
  name?: string;
  custom_properties?: Record<string, unknown>;
};

export type CreateSubscriptionV2Input = Parameters<
  typeof eden.payments.v2.createSubscription.post
>[0];

export type CreateSubscriptionV3Input = Parameters<typeof eden.payments.v3.capturePayment.post>[0];

type _CCBillAuthTokenEndpoint = (typeof eden.payments.v3)["auth-token"]["get"];
export type CCBillAuthTokenResponse = InferModel<_CCBillAuthTokenEndpoint>;

export type CaptureUpsellPaymentV2Input = Parameters<
  typeof eden.payments.v2.captureUpsellPayment.post
>[0];

export type ServerResponseError = {
  status: number;
  value:
    | string
    | {
        code: ApiErrorCodeType;
        status: number;
        type?: DomainErrorType;
        userMessage?: string;
      };
};

export type CreateUserInput = {
  email: string;
  birth_place_lat?: number;
  birth_place_lng?: number;
  dob_utc?: string;
} & QuizState;

export type TrackablePurchaseType = NonNullable<
  CreateSubscriptionV2Input["tracking"]
>["purchaseProductType"];

export type UserGeolocation = InferModel<typeof eden.geolocation.info.get>;

export type UpsertWebSessionInput = Parameters<typeof eden.session.post>[0];
export type WebSession = InferModel<typeof eden.session.post>;

export type OrderData = InferModel<typeof eden.payments.v2.orders.details.get>;
